<script setup>
import emptyWaveImg from '@/assets/images/empty-wave@2x.png';
import Button from '@/components/foundation/Button.vue';
</script>

<template>
  <div class="not-found">
    <img :src="emptyWaveImg" title="Page not found" />
    <h3>Oops, you seem to be lost</h3>
    <p>The page you are looking for doesn’t exist.</p>
    <p><Button :to="{ name: 'auth.login' }" class="home" rectangular>Take me home</Button></p>
  </div>
</template>

<style lang="postcss">
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 700px;
  margin: 120px auto;
  padding: var(--space-12);

  h3 {
    margin: var(--space-40) 0 var(--space-24);
    text-transform: uppercase;
  }

  p {
    font-size: var(--x18);
    line-height: var(--space-24);
    margin-bottom: var(--space-32);
  }

  img {
    height: 160px;
    width: 160px;
  }

  .home {
    text-transform: uppercase;
  }
}

@media (max-width: 600px) {
  .not-found {
    margin: 100px auto;

    img {
      width: 10rem;
      height: auto;
    }

    h3 {
      font-size: var(--x20);
    }

    p {
      font-size: var(--x14);
    }
  }
}
</style>
